module.exports = __webpack_public_path__ + "static/media/AB_ZW10_8.3a233527.jpg";